type CallbackFunction = () => void;

export default function keyHandler(event: KeyboardEvent, keycode: string[], cb: CallbackFunction) {
  keycode = ['Space', 'Enter', ...keycode];

  if (keycode.includes(event.code)) {
    event.preventDefault();
    return cb();
  }
}
